import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/provider/$providerId/tools')({
  head: () => ({ meta: [{ title: 'Tools' }] }),
  component: Outlet,
});
